export function debounce(fn: Function, delay = 500) {
  let timer: number

  return function (...args: any[]) {
    if (timer) clearTimeout(timer)

    // @ts-ignore
    const context = this

    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}
